import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["filterable"]

  handleCategoryChange() {
    this.filter()
    this.renderCategoryCounter()
  }

  handleQueryChange() {
    this.filter()
  }

  filter() {
    let lowerCaseFilterTerm = this.element.querySelector("input[type='search']").value.toLowerCase();
    let checkedCategories = this.checkedCategories.map(el => el.value.toLowerCase());

    this.filterableTargets.forEach((el) => {
      let filterableKey = el.getAttribute("data-filter-key").toLowerCase();
      let matchesCategory = checkedCategories.length === 0 || checkedCategories.some(category => filterableKey.includes(category));
      let matchesSearch = lowerCaseFilterTerm === '' || filterableKey.includes(lowerCaseFilterTerm);

      // Show the element if it matches the search term AND is in one of the selected categories
      let matches = matchesCategory && matchesSearch;
      el.classList.toggle("filter--not-found", !matches);
    })
    this.toggleReset(lowerCaseFilterTerm)
  }

  toggleReset(query = '') {
    if (this.checkedCategories.length > 0 || query.length > 0) {
      this.resetButton.classList.remove("hidden")
    } else {
      this.resetButton.classList.add("hidden")
    }
  }

  renderCategoryCounter() {
    const label = this.element.querySelector(".selected-container")
    label.textContent = `${this.checkedCategories.length} Selected`
  }

  resetForm() {
    this.element.querySelector(".search-filter").reset()
    this.filter()
    this.renderCategoryCounter()
    this.resetButton.classList.add("hidden")
  }

  get checkedCategories() {
    return Array.from(this.element.querySelectorAll('.js-category-checkbox:checked'))
  }

  get resetButton() {
    return this.element.querySelector(".reset")
  }
}



